import { Halflogoicon } from "assests";

const EmptyTable = ({ colSpan, text }) => {
  return (
    <tr>
      <td colSpan={colSpan} className="text-center py-3">
        <div
          className={`w-full  flex-col justify-center items-center gap-3 inline-flex p-6 
                        }`}
        >
          <div className="flex items-center justify-center ">
            <div
              className={`bg-white flex items-center justify-center  border border-global-gray-soft w-14 h-14 rounded-xl`}
              style={{
                boxShadow:
                  "rgba(16, 24, 40, 0.05) 0px 1px 2px 0px, rgba(1, 24, 50, 0.06) 0px 0px 0px .5px inset, rgba(16, 24, 40, 0.05) 0px -2px 0px 0px inset",
              }}
            >
              <Halflogoicon width={28} height={26} />
            </div>
          </div>

          {text ? (
            <p className="text-lg font-semibold  leading-[38px] text-gray-950">{text}</p>
          ) : (
            <div>
              <p className="text-lg font-semibold  leading-[38px] text-gray-950">
                Nothing here yet.
              </p>
              <p className="text-base font-normal text-gray-800">
                This space is waiting for content.
              </p>
            </div>
          )}
        </div>
      </td>
    </tr>
  );
};

export default EmptyTable;
